<app-search
  [focusedAsDefault]="focusedAsDefault"
  [clearCodeAfterChange]="false"
  [value]="initialTerm"
  placeholder="EAN scannen oder Titel / Stichwort / Kartennummer eingeben"
  (searchChanged)="search$.next($event)"
/>

<nz-spin [nzSpinning]="loading">
  <div class="finder-hint" *ngIf="!searched && !loading">
    <i nz-icon nzType="barcode" nzTheme="outline"></i>
    <p>Artikel-EAN scannen oder Titel, Stichwort bzw. Kartennummer eingeben.</p>
  </div>

  <nz-empty
    *ngIf="searched && !loading && recipeCards.length === 0"
    [nzNotFoundContent]="'Keine Rezeptkarte für „' + lastTerm + '“ gefunden.'"
  />

  <p class="finder-count" *ngIf="!loading && totalResults > 1">
    {{ totalResults }} Rezeptkarten gefunden
  </p>

  <div class="recipe-cards" *ngIf="recipeCards.length">
    <article class="recipe-preview" *ngFor="let card of recipeCards">
      <div class="recipe-preview__body">
        <div
          class="recipe-preview__front"
          *ngIf="openPdfKey(card) as key; else noPreview"
        >
          <button
            #openPdfBtn
            type="button"
            class="recipe-preview__open-pdf-trigger"
            tabindex="-1"
            aria-hidden="true"
            appOpenPdf
            [key]="key"
          ></button>
          <button
            type="button"
            class="recipe-preview__pdf-tile"
            (dblclick)="openPdfBtn.click()"
          >
            <i nz-icon nzType="file-pdf" nzTheme="outline"></i>
            <span class="recipe-preview__pdf-number">Nr. {{ card.number }}</span>
            <span class="recipe-preview__pdf-hint">Doppelklick öffnet PDF</span>
          </button>
        </div>
        <ng-template #noPreview>
          <div class="recipe-preview__front recipe-preview__front--empty">
            <i nz-icon nzType="file-image" nzTheme="outline"></i>
            <span>Kein PDF vorhanden</span>
          </div>
        </ng-template>

        <div class="recipe-preview__content">
          <header class="recipe-preview__header">
            <div class="recipe-preview__number">
              <span class="recipe-preview__number-label">Nr.</span>
              <span class="recipe-preview__number-value">{{ card.number }}</span>
            </div>

            <div class="recipe-preview__title-block">
              <h3 class="recipe-preview__title">{{ card.title }}</h3>
              <div class="recipe-preview__keywords" *ngIf="keywords(card).length">
                <nz-tag *ngFor="let keyword of keywords(card)" nzColor="blue">{{ keyword }}</nz-tag>
              </div>
              <p class="recipe-preview__product" *ngIf="card.cardArticleFullName">
                {{ card.cardArticleFullName }}
              </p>
            </div>
          </header>

          <div class="recipe-preview__times">
            <div class="recipe-preview__time">
              <span class="recipe-preview__time-label">Vorbereitung</span>
              <span class="recipe-preview__time-value">{{ formatMinutes(card.prepareTime) }}</span>
            </div>
            <div class="recipe-preview__time">
              <span class="recipe-preview__time-label">Kochzeit</span>
              <span class="recipe-preview__time-value">{{ formatMinutes(card.cookTime) }}</span>
            </div>
            <div class="recipe-preview__time recipe-preview__time--total">
              <span class="recipe-preview__time-label">Gesamt</span>
              <span class="recipe-preview__time-value">{{ formatMinutes(card.totalTime) }}</span>
            </div>
          </div>

          <section class="recipe-preview__section" *ngIf="ingredients(card).length">
            <h4 class="recipe-preview__section-title">Zutaten</h4>
            <div class="recipe-preview__tags">
              <nz-tag *ngFor="let ingredient of ingredients(card)">{{ ingredient }}</nz-tag>
            </div>
          </section>
        </div>
      </div>

      <footer class="recipe-preview__actions">
        <button
          *ngIf="openPdfKey(card) as key"
          nz-button
          nzType="primary"
          appOpenPdf
          [key]="key"
        >
          <i nz-icon nzType="file-pdf" nzTheme="outline"></i>
          PDF öffnen
        </button>

        <button
          *ngIf="backPdfKey(card) as backKey"
          nz-button
          nzType="default"
          appOpenPdf
          [key]="backKey"
        >
          <i nz-icon nzType="file-pdf" nzTheme="outline"></i>
          Rückseite öffnen
        </button>

        <a
          *ngIf="printerLink(card) as link"
          nz-button
          nzType="default"
          [routerLink]="link"
        >
          <i nz-icon nzType="printer" nzTheme="outline"></i>
          Rezeptkartendrucker
        </a>

        <a
          *ngIf="shopwareLink(card) as link"
          nz-button
          nzType="default"
          [href]="link"
          target="_blank"
          rel="noopener"
        >
          <i nz-icon nzType="shop" nzTheme="outline"></i>
          Shopware
        </a>
      </footer>
    </article>
  </div>
</nz-spin>
